export default __webpack_public_path__ + "static/box-a45f120b8ca7f16f77c8d92185984500.png";